<template>
  <ProtocolEditComponent
    :local="true"
    :new="false"
    :id="this.$route.params.id"
  />
</template>

<script>
import ProtocolEditComponent from '../../components/protocols/ProtocolEditComponent'
export default {
  name: 'LocalProtocolEdit',
  components: {ProtocolEditComponent}
}
</script>



// WEBPACK FOOTER //
// src/views/local/ProtocolEdit.vue